import styled from 'styled-components'

export const Container = styled.div`
  grid-area: header;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;
  margin-right: var(--dashboard-padding-x);
  margin-left: var(--dashboard-padding-x);
`
export const Content = styled.div`
  grid-area: content;
`
